import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import Table from 'semantic-table-grid';

const FiltersContainer = styled.div`
  background: #efefef;
  border: 1px solid #ccc;
  border-radius: 3;
  padding: 11px;
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;

  .dropdown-container {
    width: 100%;
    max-width: 450px;

    span {
      font-weight: bolder;
      padding-left: 2px;
    }
  }

  .buttons-collection {
    display: flex;
    width: 150px;
  }
`;

export class AgencyTable extends React.Component {
  payinFormatValue = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  profiliColumns = [
    {
      key: 'name',
      name: <div style={{ textAlign: 'center' }}>Nome</div>,
      formatter: ({ data }) => <div style={{ textAlign: 'left' }}>{data.name}</div>,
    },
    {
      key: 'profile',
      name: <div style={{ textAlign: 'center' }}>Profilo</div>,
      formatter: ({ data }) => <div style={{ textAlign: 'left' }}>{data.profile}</div>,
    },
    {
      key: 'role',
      name: <div style={{ textAlign: 'center' }}>Ruolo</div>,
      formatter: ({ data }) => <div style={{ textAlign: 'left' }}>{data.role}</div>,
    },
    {
      key: 'tutoring',
      name: <div style={{ textAlign: 'center' }}>Tutoring</div>,
      formatter: ({ data }) => <div style={{ textAlign: 'left' }}>{data.tutoring}</div>,
    },
    {
      key: 'experience',
      name: <div style={{ textAlign: 'center' }}>Esperienza (mesi)</div>,
      formatter: ({ data }) => <div style={{ textAlign: 'center' }}>{data.experience}</div>,
    },
    {
      key: 'payin',
      name: <div style={{ textAlign: 'center' }}>Payin anno</div>,
      formatter: ({ data }) => (
        <div style={{ textAlign: 'center' }}>
          {_.isNumber(data.payin) ? this.payinFormatValue.format(data.payin) : '- - -'}
        </div>
      ),
    },
  ];

  render() {
    return (
      <div>
        <FiltersContainer>
          <div className="dropdown-container">
            <span>Agenzia</span>
            <Dropdown
              fluid
              loading={this.props.areAgenciesLoading}
              options={this.props.agenciesOptions}
              placeholder="- - -"
              search
              selection
              disabled={_.isEmpty(this.props.agenciesOptions)}
              value={this.props.selectedAgency}
              onChange={(_e, { value }) => this.props.onChangeAgency(value)}
            />
          </div>
        </FiltersContainer>
        <Table
          columns={this.profiliColumns}
          elements={this.props.agencyData}
          isLoading={this.props.areAgencyDataloading}
        />
      </div>
    );
  }
}

AgencyTable.propTypes = {
  agencyData: PropTypes.array,
  agenciesOptions: PropTypes.array,
  areAgenciesLoading: PropTypes.bool,
  areAgencyDataloading: PropTypes.bool,
  onChangeAgency: PropTypes.func,
  selectedAgency: PropTypes.string,
};

export default AgencyTable;



// WEBPACK FOOTER //
// ./app/components/NetworkDashboard/AgencyTable/index.js